module.exports = __webpack_public_path__ + "img/covilha.50d65dcc.jpg";